// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tSKJU","colBig":"styles_colBig__1SgVG","colSmall":"styles_colSmall__1iohO","shopifyNameWrapper":"styles_shopifyNameWrapper__vvwGq"};